module.exports = __webpack_public_path__ + "media/images/menu/solar_system-fad3716343c40f7346a18aa5e92b8526.jpg";